import { Point } from '../../../../../common/maths/geometry/pointTypes';
import { RectSize } from '../../../../../common/maths/geometry/rect/rectTypes';

export type ImageModalZoomState = {
    scale: number;
    translation: Point;
};

export type ImageModalZoomBounds = {
    minScale?: number;
    maxScale?: number;
};

export type ImageModalZoomDimensions = {
    viewportSize: RectSize;
    contentSize: RectSize;
};

export const DEFAULT_IMAGE_MODAL_ZOOM_STATE: ImageModalZoomState = {
    scale: 1,
    translation: {
        x: 0,
        y: 0,
    },
};
export const DEFAULT_IMAGE_MODAL_MIN_SCALE = 1;
export const DEFAULT_IMAGE_MODAL_MAX_SCALE = 4;

/**
 * Returns the default zoom state for the image modal.
 */
export const resetZoomState = (): ImageModalZoomState => ({
    scale: DEFAULT_IMAGE_MODAL_ZOOM_STATE.scale,
    translation: {
        x: DEFAULT_IMAGE_MODAL_ZOOM_STATE.translation.x,
        y: DEFAULT_IMAGE_MODAL_ZOOM_STATE.translation.y,
    },
});
